module.exports = __webpack_public_path__ + "img/neocampus.24205e71.jpg";